import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
  },
  iconContainer: {
    height: '4.8rem',
    minWidth: '4.8rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    marginRight: '1.6rem',
    borderRadius: '1rem',
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
  },
  icon: {
    height: '2.4rem',
    width: '2.4rem',
    fontSize: '2.4rem',
    display: 'block',
  },
  titleText: {
    '&::first-letter': {
      textTransform: 'capitalize',
    },
  },
}));

export default useStyles;